import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { AssignmentStatus } from "../model/model";
import * as helper from "./../helpers/util";

@Component({
  selector: "app-status-button",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  styles: [``],
  template: `<button
    (click)="clicked()"
    [class.disabled]="disabled"
    [class.active]="active"
    class="btn btn-outline-dark btn-block d-flex align-items-center mb-1"
  >
    <img class="img-status" width="24" height="24" [src]="iconUrl" /><span
      class="pl-2"
      >{{ buttonTranslateKey | translate }}</span
    >
  </button>`,
})
export class StatusButtonComponent implements OnInit {
  @Input() state: AssignmentStatus;
  @Input() disabled = false;
  @Input() active = false;
  @Output() click = new EventEmitter<AssignmentStatus>();
  iconUrl = "";
  buttonTranslateKey = "";

  constructor() {}

  ngOnInit(): void {
    const statusInfo = helper.getStateIcons()[this.state];
    this.iconUrl = statusInfo.url;
    this.buttonTranslateKey = statusInfo.actiontext;
  }

  clicked() {
    if (!this.disabled) {
      this.click.emit(this.state);
    }
  }
}
